export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datos de la programación"])},
          "manage_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Gestionar"])},
          "destroy_button_label": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])},
          "destroy_button_title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar servicio"])},
          "destroy_button_message": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["¿Está seguro de eliminar el servicio?"])},
          "destroy_button_label_confirm": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Eliminar"])},
          "edit_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Editar"])},
          "edit_technicians": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Responsables"])},
          "edit_service_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Registro"])},
          "attchments_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Adjuntos"])},
          "change_container_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Cambiar contenedor"])},
          "add_container_button": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Asignar contenedor"])},
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a lista de servicios"])}
        }
      }
    }
  })
}